type PlayerData = Record<string, unknown> & { position?: number };
type Players = Record<string, PlayerData>;

/**
 * Assigns a position (1st, 2nd, ...) to each player based on descending score.
 * @param players - Object with playerId keys and a score field
 * @param options.scoreField - The field to sort by (default: "score")
 * @returns New object with a `position` field added to each player
 */
function assignPositions(players: Players, { scoreField = "score" } = {}): Players {
	const result: Players = {};
	const entries = Object.entries(players);

	entries.sort(([, a], [, b]) => (b[scoreField] as number) - (a[scoreField] as number));

	let position = 1;
	let lastScore: number | null = null;
	let skip = 0;

	for (let i = 0; i < entries.length; i++) {
		const [playerId, playerData] = entries[i];
		const score = playerData[scoreField] as number;

		if (score !== lastScore) {
			position += skip;
			skip = 1;
			lastScore = score;
		} else {
			skip++;
		}

		result[playerId] = { ...playerData, position };
	}

	return result;
}

export default assignPositions;
